// extracted by mini-css-extract-plugin
module.exports = {"container":"_c73c903","valueRed":"_702d4d1"};